"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapEmployeeApiResponseToUser = exports.getDepartmentIdFromIdent = exports.getDepartmentIdFromBosEmployee = exports.mapEmployeeRolesApiResponseToUser = void 0;
const reference_1 = require("./reference");
const mapEmployeeRolesApiResponseToUser = (roles) => roles.map((role) => {
    return {
        brandCode: role === null || role === void 0 ? void 0 : role.brandCode,
        contractType: role === null || role === void 0 ? void 0 : role.contractType,
        dealer: {
            dealerId: role === null || role === void 0 ? void 0 : role.dealerId,
            id: role === null || role === void 0 ? void 0 : role.dealerId,
            name: role === null || role === void 0 ? void 0 : role.dealerName,
        },
        modelCode: role === null || role === void 0 ? void 0 : role.modelCode,
        role: role === null || role === void 0 ? void 0 : role.role,
    };
});
exports.mapEmployeeRolesApiResponseToUser = mapEmployeeRolesApiResponseToUser;
const getDepartmentIdFromBosEmployee = (bosEmployee) => {
    var _a, _b;
    const firstEmployeeRoleDefault = ((_a = bosEmployee === null || bosEmployee === void 0 ? void 0 : bosEmployee.employeeRoles) === null || _a === void 0 ? void 0 : _a.length) > 0 ? ((_b = bosEmployee === null || bosEmployee === void 0 ? void 0 : bosEmployee.employeeRoles[0]) === null || _b === void 0 ? void 0 : _b.dealerId) || null : null; // temp selected dealerId
    return (0, exports.getDepartmentIdFromIdent)(bosEmployee === null || bosEmployee === void 0 ? void 0 : bosEmployee.employeeId, firstEmployeeRoleDefault);
};
exports.getDepartmentIdFromBosEmployee = getDepartmentIdFromBosEmployee;
const getDepartmentIdFromIdent = (ident, defaultValue = null) => {
    if (typeof ident !== 'string')
        return defaultValue;
    const identSubstring = (ident === null || ident === void 0 ? void 0 : ident.substring(1, 4)) || null;
    return !isNaN(parseInt(identSubstring))
        ? identSubstring
        : identSubstring.toLowerCase() === 'edb'
            ? '799'
            : defaultValue;
};
exports.getDepartmentIdFromIdent = getDepartmentIdFromIdent;
const mapEmployeeApiResponseToUser = (employee) => {
    const departmentId = (0, exports.getDepartmentIdFromBosEmployee)(employee);
    return {
        departmentId,
        email: (employee === null || employee === void 0 ? void 0 : employee.email) || null,
        emailVerifiedForSantanderSale: employee.emailVerifiedForSantanderSale,
        employeeId: (employee === null || employee === void 0 ? void 0 : employee.employeeId) || null,
        employeeRoles: (0, exports.mapEmployeeRolesApiResponseToUser)(employee === null || employee === void 0 ? void 0 : employee.employeeRoles),
        firstName: (employee === null || employee === void 0 ? void 0 : employee.firstName) || null,
        groups: [],
        id: (employee === null || employee === void 0 ? void 0 : employee.id) || null,
        ident: (employee === null || employee === void 0 ? void 0 : employee.employeeId) || null,
        lastName: (employee === null || employee === void 0 ? void 0 : employee.lastName) || null,
        mobilePhone: (employee === null || employee === void 0 ? void 0 : employee.phone) || null,
        reference: Object.assign(Object.assign({}, (0, reference_1.getEmptyReference)()), { bosApiId: employee === null || employee === void 0 ? void 0 : employee.id }),
        timestamp: parseInt(employee.timestamp),
    };
};
exports.mapEmployeeApiResponseToUser = mapEmployeeApiResponseToUser;
//# sourceMappingURL=user.js.map